import { render, staticRenderFns } from "./SpecialtyProfile.vue?vue&type=template&id=94f05c96&scoped=true&"
import script from "./SpecialtyProfile.vue?vue&type=script&lang=js&"
export * from "./SpecialtyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f05c96",
  null
  
)

export default component.exports